export const CommunicationConditons = [
  { key: 1, text: 'Between', value: 'Between' },
  { key: 2, text: 'Not Between', value: 'Not Between' },

  { key: 3, text: 'Equal To', value: 'Equal To' },
  { key: 4, text: 'Not Equal To', value: 'Not Equal To' },
  { key: 5, text: 'Greater Than', value: 'Greater Than' },
  { key: 6, text: 'Less Than', value: 'Less Than' },
  {
    key: 7,
    text: 'Greater Than or Equal To',
    value: 'Greater Than or Equal To',
  },
  { key: 8, text: 'Less Than or Equal To', value: 'Less Than or Equal To' },

  { key: 9, text: 'Contains', value: 'Contains' },
  { key: 10, text: 'Not Contains', value: 'Not Contains' },
  { key: 11, text: 'Beginning With', value: 'Beginning With' },
  { key: 12, text: 'Ending With', value: 'Ending With' },

  { key: 13, text: 'Date Occuring', value: 'Date Occuring' },
];
export const CommunicationTodayOptions = [
  { key: 1, text: 'Yesterday', value: 'Yesterday' },
  { key: 2, text: 'Today', value: 'Today' },
  { key: 3, text: 'Tomorrow', value: 'Tomorrow' },
  { key: 4, text: 'In the last 7 days', value: 'In the last 7 days' },
  { key: 5, text: 'Last Week', value: 'Last Week' },
  { key: 6, text: 'This Week', value: 'Greater Than' },
  { key: 7, text: 'Next Week', value: 'Next Week' },
  { key: 8, text: 'Last Month', value: 'Last Month' },
  { key: 9, text: 'This Month', value: 'This Month' },
  { key: 10, text: 'Next Month', value: 'Next Month' },
];
export const OccuranceOptions = [
  { key: 1, text: 'Weekly', value: 'Weekly' },
  { key: 2, text: 'Monthly', value: 'Monthly' },
  { key: 3, text: 'Daily', value: 'Daily' },
  { key: 4, text: 'OnChange', value: 'OnChange' },
];
